import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, forwardRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[twoDecimalInput]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TwoDecimalInputDirective),
            multi: true,
        },
        DecimalPipe,
    ],
})
export class TwoDecimalInputDirective implements ControlValueAccessor {
    private onChange: (value: number | null) => void;
    private onTouched: () => void;

    constructor(
        private readonly el: ElementRef<HTMLInputElement>,
        private readonly decimalPipe: DecimalPipe,
    ) {}

    writeValue(value: number | null): void {
        if (value == null || isNaN(value)) {
            this.el.nativeElement.value = '';
            return;
        }
        // Used DecimalPipe to format, then remove commas
        const formatted = this.decimalPipe.transform(value, '1.2-2') ?? '';
        this.el.nativeElement.value = formatted.replace(/,/g, '');
    }

    registerOnChange(fn: (value: number | null) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    @HostListener('input', ['$event.target.value'])
    onInput(rawValue: string): void {
        // Remove commas from user input
        const numericValue = parseFloat(rawValue.replace(/,/g, ''));
        if (!isNaN(numericValue)) {
            this.onChange(numericValue);
        } else {
            this.onChange(null);
        }
    }

    @HostListener('blur')
    onBlur(): void {
        this.onTouched?.();
        const numericValue = parseFloat(
            this.el.nativeElement.value.replace(/,/g, ''),
        );
        if (!isNaN(numericValue)) {
            const formatted =
                this.decimalPipe.transform(numericValue, '1.2-2') ?? '';
            this.el.nativeElement.value = formatted.replace(/,/g, '');
        } else {
            this.el.nativeElement.value = '';
        }
    }
}
